module.exports = __webpack_public_path__ + "static/media/(980039).a72d32ce.jpg";